"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ItemForm_module_scss_1 = __importDefault(require("./ItemForm.module.scss"));
const async_1 = __importDefault(require("react-select/async"));
const feed_factory_location_card_1 = __importDefault(require("@feed-factory/feed-factory.location-card"));
const feed_factory_popovers_boolean_input_popover_1 = __importDefault(require("@feed-factory/feed-factory.popovers.boolean-input-popover"));
const feed_factory_buttons_1 = require("@feed-factory/feed-factory.buttons");
const fa_1 = require("react-icons/fa");
const md_1 = require("react-icons/md");
const feed_factory_models_lang_1 = require("@feed-factory/feed-factory.models.lang");
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const string_similarity_1 = __importDefault(require("string-similarity"));
const react_i18next_1 = require("react-i18next");
const getItemTitle = (item, mainLang) => {
    var _a, _b, _c, _d, _e, _f, _g;
    // check if title in primary language of event item is available
    if ((_b = (_a = item.trcItemDetails) === null || _a === void 0 ? void 0 : _a[mainLang]) === null || _b === void 0 ? void 0 : _b.title)
        return item.trcItemDetails.nl.title;
    // Get title in primary language of location
    const locPrimaryLang = ((_c = item.translations) === null || _c === void 0 ? void 0 : _c.primaryLanguage) || feed_factory_models_lang_1.Lang.NL;
    if ((_e = (_d = item.trcItemDetails) === null || _d === void 0 ? void 0 : _d[locPrimaryLang]) === null || _e === void 0 ? void 0 : _e.title)
        return (_g = (_f = item.trcItemDetails) === null || _f === void 0 ? void 0 : _f[locPrimaryLang]) === null || _g === void 0 ? void 0 : _g.title;
    return "no title";
};
const toTitleCase = (str) => {
    if (!str || str.length < 1) {
        return "";
    }
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
const fetchLocationsByQuery = (inputValue, primaryLang, userOrganisations) => __awaiter(void 0, void 0, void 0, function* () {
    const resultsToShow = 100;
    const res = yield feed_factory_helpers_1.feedFactoryAxios.get(`/locations?size=${resultsToShow}&page=0&search=${inputValue.toLowerCase()}&userorganisation=${userOrganisations ? userOrganisations.join(";") : "*"}`);
    const rawLocations = (0, feed_factory_helpers_1.externalResultsToInternalResults)(res.data);
    return rawLocations.results
        .map((location) => {
        var _a;
        const address = (_a = location.location) === null || _a === void 0 ? void 0 : _a.address;
        const locationLabel = `${getItemTitle(location, primaryLang)} (${toTitleCase(address === null || address === void 0 ? void 0 : address.city)}, ${address === null || address === void 0 ? void 0 : address.street} ${address === null || address === void 0 ? void 0 : address.housenr})`;
        return {
            label: locationLabel,
            value: location.id,
            distance: string_similarity_1.default.compareTwoStrings(inputValue, locationLabel),
        };
    })
        .sort((a, b) => {
        if (a.distance > b.distance)
            return -1;
        if (a.distance < b.distance)
            return 1;
        return 0;
    })
        .map((option) => ({
        label: option.label,
        value: option.value,
    }));
});
const LocationSelector = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [locationItem, setLocationItem] = (0, react_1.useState)(null);
    const locationItemId = props.value;
    (0, react_1.useEffect)(() => {
        // Only set location if item type is event
        if (!locationItemId) {
            setLocationItem(null);
            return;
        }
        feed_factory_helpers_1.feedFactoryAxios.get(`/locations/${locationItemId}`).then((res) => {
            const myLocation = (0, feed_factory_helpers_1.externalToInternal)(res.data);
            setLocationItem(myLocation);
        });
    }, [locationItemId]);
    // TODO: Consider adding debounce
    const updateLocations = (inputValue) => __awaiter(void 0, void 0, void 0, function* () {
        return fetchLocationsByQuery(inputValue, props.lang, props.filterOnUserOrganisations);
    });
    const changeLocation = (option) => {
        feed_factory_helpers_1.feedFactoryAxios.get(`/locations/${option.value}`).then((res) => {
            const myLocation = (0, feed_factory_helpers_1.externalToInternal)(res.data);
            setLocationItem(myLocation);
            if (props.onSelect) {
                props.onSelect(myLocation);
            }
        });
    };
    const removeLocationLink = () => {
        if (!locationItem) {
            return;
        }
        setLocationItem(null);
        if (props.onSelect) {
            props.onSelect(null);
        }
    };
    return (react_1.default.createElement("div", { className: ItemForm_module_scss_1.default.locationItemWrapper },
        !locationItem && (react_1.default.createElement(async_1.default, { cacheOptions: true, defaultOptions: true, loadOptions: updateLocations, className: ItemForm_module_scss_1.default.asyncSelect, 
            // @ts-ignore
            onChange: (option) => {
                changeLocation(option);
            }, placeholder: t("root.selectLocationItem") })),
        locationItem && (react_1.default.createElement(feed_factory_location_card_1.default, { className: ItemForm_module_scss_1.default.locationCard, lang: props.lang, entry: locationItem, openInNewTab: true, userorganisations: props.myUserOrganisations, locationUrl: props.locationUrl, minimalDisplay: props.minimalCardDisplay })),
        locationItem ? (react_1.default.createElement("div", { className: ItemForm_module_scss_1.default.locationItemButtonsWrapper },
            react_1.default.createElement(feed_factory_popovers_boolean_input_popover_1.default, { onBooleanSubmit: (deletion) => {
                    if (deletion)
                        removeLocationLink();
                }, prompt: t("form.unlinkLocationItemPrompt"), type: "danger" }, (setPopover, onButtonClickHandler) => (react_1.default.createElement(feed_factory_buttons_1.PopupButton, { type: feed_factory_buttons_1.ButtonType.Failure, action: onButtonClickHandler, className: ItemForm_module_scss_1.default.locationItemsButton },
                react_1.default.createElement(fa_1.FaUnlink, null),
                " ",
                react_1.default.createElement("span", { className: ItemForm_module_scss_1.default.collapsable }, t("root.unlinkLocationItem")),
                react_1.default.createElement("span", { ref: setPopover })))),
            props.onCopy && (react_1.default.createElement(feed_factory_popovers_boolean_input_popover_1.default, { onBooleanSubmit: (copy) => {
                    if (copy)
                        props.onCopy && props.onCopy(locationItem);
                }, prompt: t("form.copyLocationTemplatePrompt"), type: "danger" }, (setPopover, onButtonClickHandler) => (react_1.default.createElement(feed_factory_buttons_1.PopupButton, { action: () => {
                    // Commit 89015beb9a69d8d9fcb7a953bbbcfd412841d630 contains code to check if copy is novel
                    // It then prevents any dialogue opening if then items are identical
                    // Not worth the refactoring, however
                    onButtonClickHandler();
                }, className: ItemForm_module_scss_1.default.locationItemsButton },
                react_1.default.createElement(fa_1.FaCopy, null),
                react_1.default.createElement("span", { className: ItemForm_module_scss_1.default.collapsable }, t("root.copyLocationTemplate")),
                react_1.default.createElement("span", { ref: setPopover }))))))) : (react_1.default.createElement("div", { className: ItemForm_module_scss_1.default.noLocationItemSelectedWrapper },
            react_1.default.createElement("div", null,
                react_1.default.createElement(md_1.MdLocationOff, null),
                t("root.noLocationItemSelected"))))));
};
exports.default = LocationSelector;
//# sourceMappingURL=LocationSelector.js.map